import { styled } from "@/stitches/config"

export const SHidden = styled("div", {})
